<div class="select-driver-list-item-container">
  <div [ngClass]="{ graySpace: isIgnoringProvider }" class="driver">
    <h3 id="selectDriverListItem-text-driverName-{{ driver.id }}" data-private>{{ driver.firstName }} {{ driver.lastName }}</h3>
    <small *ngIf="driver.emailAddress" id="selectDriverListItem-text-driverEmail-{{ driver.id }}" data-private>
      {{ driver.emailAddress }}
    </small>
    <small
      [ngClass]="{ 'call-number': notOnPlatform || isIgnoringProvider }"
      *ngIf="driver.phoneNumber"
      id="selectDriverListItem-text-phoneNumber-{{ driver.id }}"
      data-private
    >
      {{ driver.phoneNumber | phone }}
      <mat-icon *ngIf="notOnPlatform || isIgnoringProvider" class="material-icons-two-tone">phone_forwarded</mat-icon>
    </small>
  </div>
  <div class="vehicle" *ngIf="vehicle">
    <span id="selectDriverListItem-text-vehicle-{{ driver.id }}"> {{ vehicle.color }} {{ vehicle.make }} {{ vehicle.model }} </span>
  </div>
  <div class="action" *ngIf="!isIgnoringProvider">
    <button id="selectDriverListItem-button-select-{{ driver.id }}" mat-raised-button color="primary" (click)="selectInterestedDriver()">
      Select {{ selectionText }}
    </button>
  </div>
</div>
